import { render, staticRenderFns } from "./CourseRecList.vue?vue&type=template&id=110c3b90&scoped=true&"
import script from "./CourseRecList.vue?vue&type=script&lang=js&"
export * from "./CourseRecList.vue?vue&type=script&lang=js&"
import style0 from "./CourseRecList.vue?vue&type=style&index=0&id=110c3b90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c3b90",
  null
  
)

export default component.exports